<!--
 * @FileDescription: 销售订单——待支付详情
 * @Author: ryb（作者）
 * @Date: 2020-07-16（时间）
 -->
<template>
  <div class="sales-order-unpaid">
    <div class="sales-order-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col>
          <span class="a-col-title">单据单号：</span>
          <span class="a-col-value">{{ dataDetails.code }}</span>
        </a-col>
        <a-col style="margin-right: 0">
          <span class="a-col-title">单据日期：</span>
          <span class="a-col-value">{{ dataDetails.orderDate }}</span>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">收货人：</span>
          <span class="a-col-value">{{ dataDetails.receiveName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">发货门店：</span>
          <span class="a-col-value">{{ dataDetails.outStoreName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">备注：</span>
          <span class="a-col-value">
            <a-input placeholder="请输入订单备注" v-model="formData.remark" />
          </span>
        </a-col>
      </a-row>
    </div>
    <div class="sales-order-content" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataSource" :pagination="false" rowKey="id" :scroll="{ y: tableHeight }"
        bordered>
        <!-- 序号 -->
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{  index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="goodsName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="goodsCode" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 底部合计 -->
        <template slot="footer">
          <div class="footer-total-amount">
            <div class="footer-total-amount-left" style="width: 80px">
              <span class="title">小计</span>
            </div>
            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
              <span class="right-col">数量：{{ footerDataSource[0].totalCount }}</span>
              <span class="right-col">金额：{{ footerDataSource[0].totalAmount }}</span>
            </div>
          </div>
        </template>
      </a-table>
    </div>
    <div class="sales-order-footer" id="page-footer">
      <a-row>
        <a-col>
          <span class="a-col-title">加收费用：</span>
          <span class="a-col-value">
            <a-input-number placeholder="请输入费用" :min="0" v-model="formData.otherExpensesAmount" style="width: 100px">
            </a-input-number>
          </span>
        </a-col>
        <a-col>
          <span class="a-col-title">优惠金额：</span>
          <span class="a-col-value">
            <a-input-number placeholder="请输入金额" :min="0" type="number" v-model="formData.discountAmount" style="width: 100px"></a-input-number>
          </span>
        </a-col>
        <a-col>
          <span class="a-col-title">合计：</span>
          <span class="a-col-value a-col-order-price">
            ¥<span class="order-price">{{ formData.totalAmount }}</span>
          </span>
        </a-col>
      </a-row>
    </div>
    <!-- 底部按钮组件 -->
    <public-footer ref="footer" :buttonList="buttonList" @onClickButton="onClickButton"></public-footer>
  </div>
</template>
<script>
import publicFooter from "@/components/module/publicFooter.vue";
import { updatePriceById } from "@/utils/cloudstoreApi";
import { tableWidth } from "@/mixins/tableWidth";
export default {
  mixins: [tableWidth],
  components: {
    publicFooter,
  },
  props: {
    orderData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          align: "center",
          width: 80,
          dataIndex: "serialNum",
          scopedSlots: { customRender: "serialNum" },
        },
        {
          defaultWidth: 200,
          title: "商品名称",
          dataIndex: "goodsName",
          ellipsis: true,
          scopedSlots: { customRender: "goodsName" },
        },
        {
          defaultWidth: 200,
          title: "商品编号",
          dataIndex: "goodsCode",
          ellipsis: true,
          scopedSlots: { customRender: "goodsCode" },
        },
        {
          title: "规格",
          ellipsis: true,
          dataIndex: "goodsSpecification",
        },
        {
          title: "型号",
          ellipsis: true,
          dataIndex: "goodsModel",
        },
        {
          defaultWidth: 120,
          title: "单位",
          ellipsis: true,
          dataIndex: "goodsUnitName",
          scopedSlots: { customRender: "goodsUnitName" },
        },
        {
          title: "数量",
          ellipsis: true,
          dataIndex: "totalCount",
        },
        {
          title: "售价",
          ellipsis: true,
          align: "right",
          dataIndex: "price",
        },
        {
          title: "金额",
          ellipsis: true,
          dataIndex: "totalAmount",
        },
      ],
      dataSource: [],
      footerDataSource: [],
      buttonList: [
        {
          id: 1,
          text: "取消退出",
        },
        {
          id: 9,
          text: "提交修改",
          class: "ant-btn-primary",
        },
      ],
      contentHeight: "",
      tableHeight: "",
      formData: {
        remark: "",
        otherExpensesAmount: "",
        discountAmount : "",
        totalAmount: "",
        id: ""
      },
      dataDetails: {},
      urlList: {},
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // 表格高度计算
      let _that = this;
      let tdHeight = document.getElementsByTagName("tr")[0].offsetHeight;
      let header = document.getElementById("header").offsetHeight;
      let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
      let pageHeight = document.getElementById("content").offsetHeight;
      let makeTop = document.getElementById("page-top").offsetHeight;
      let makeButton = document.getElementById("page-footer").offsetHeight;
      _that.contentHeight =
        pageHeight - makeTop - makeButton - header - breadcrumb - tdHeight*1.2;
      _that.tableHeight = _that.contentHeight - tdHeight * 2;
      this.formData.id = this.$route.query.id;
    },
    /**
     * 方法说明：表格增加合计行 
     * @method tableAddTotalRow
     */
    tableAddTotalRow(columns, dataSource) {
      let numKey = 'rowIndex'
      let totalRow = {
          [numKey]: '小计'
      }
      this.footerDataSource = [] // 表格最后一行数据
      columns.forEach(column => {
        let { key, dataIndex } = column
        if (![key, dataIndex].includes(numKey)) {
          let total = 0
          dataSource.forEach(data => {
            if (dataIndex == 'totalAmount') {
              if (data[dataIndex]) {
                total += Number(data[dataIndex])
              }
            } else if (dataIndex == 'totalCount') {
              if (data[dataIndex]) {
                total += Number(data[dataIndex])
              }
            } else {
              total = ''
            }
          })
          totalRow[dataIndex] = total
        }
      })
      totalRow.totalAmount = totalRow.totalAmount.toFixed(2)
      this.footerDataSource.push(totalRow)
      this.calculate()
    },
    /**
     * 方法说明：计算金额
     * @method calculate
     */
    calculate() {
      let discountAmount = this.formData.discountAmount?Number(this.formData.discountAmount) :0
      let otherExpensesAmount = this.formData.otherExpensesAmount?Number(this.formData.otherExpensesAmount) :0
      let totalAmount = Number(this.footerDataSource[0].totalAmount) + otherExpensesAmount - discountAmount
      this.formData.totalAmount = this.$comm.toDecimal2(totalAmount)
    },
    /**
     * 方法说明：提交修改
     * @method onClickButton
     */
    onClickButton() {
      let params = this.formData
      let header = {
        companyStoreId: this.$store.state.userInfo.companyStoreId
      }
      this.$store.state.isLoding = true
      updatePriceById(params,header).then((res) => {
        if (res.code == 200) {
          this.$emit("updateData")
          this.$message.success(res.logMessage)
          this.$store.state.isLoding = false
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
  },
  watch: {
    orderData() {
      this.dataDetails = this.orderData
      this.formData.remark =  this.orderData.remark
      this.formData.discountAmount =  this.orderData.discountAmount
      this.formData.otherExpensesAmount =  this.orderData.otherExpensesAmount
      this.dataSource = this.orderData.orderItemVOList
      this.tableAddTotalRow(this.columns, this.dataSource)
    },
    "formData.otherExpensesAmount"() {
      this.calculate()
    },
    "formData.discountAmount"() {
      this.calculate()
    }
  }
};
</script>

<style lang="scss">
@import "../style/salesOrderDetails.scss";
.sales-order-unpaid {
  .ant-input-number {
      border-radius: 6px !important;
  }
  .ant-input-number-handler-wrap {
      border-radius: 0px 6px 6px 0px !important;
  }
  .ant-input-number-input {
      height: 32px !important;
      background: #FAFAFA !important;
      border-radius: 6px !important;
  }
}
</style>
